import React from 'react';
import { createPortal } from 'react-dom';

export const PortalBody = ({ children }: PortalBodyProps) =>
  createPortal(children, document?.body);

type PortalBodyProps = {
  children: React.ReactNode;
};
